import Component from "@glimmer/component";
import { action } from "@ember/object";

export default class TaskForm extends Component {
  get task() {
    return this.args.task;
  }

  get isLoading() {
    return this.args.isLoading || this.task.isRunning;
  }

  @action
  onChange(event) {
    const entries = new FormData(event.currentTarget).entries();
    const grouped = Object.groupBy(entries, ([key]) => key);

    const formDataAsObject = Object.fromEntries(
      Object.entries(grouped).map(([key, pairs]) => {
        const values = pairs.map(([, value]) => value);
        return [key, values.length > 1 ? values : values[0]];
      }),
    );

    this.args.onChange?.(formDataAsObject);
  }

  @action
  submit(event) {
    event.preventDefault();
    this.task.perform();
    return false;
  }
}
